const API_PREFIX = "/api/v1/";

export const PRODUCT_API_URL = `${API_PREFIX}lansdown`;
/* export const CONFIRM_INSURANCE_API_URL = `${API_PREFIX}lansdown/confirm`; */
export const CONFIRM_INSURANCE_API_URL = `${API_PREFIX}lansdown/mta/confirm/amend`; // changed to use the same endpoint as MTA
export const SAVE_PERSON_API_URL = `${API_PREFIX}lansdown/savePerson`;

export const LOAD_QUOTE_FOR_RENEWAL_API_URL = `${API_PREFIX}lansdown/renewals`;
export const CONFIRM_QUOTE_RENEWAL_API_URL = `${API_PREFIX}lansdown/renewals/confirm`;
export const CALCULATE_QUOTE_RENEWAL_API_URL = `${API_PREFIX}lansdown/renewals/calculate`;

export const LOAD_QUOTE_FOR_MTA_API_URL = `${API_PREFIX}lansdown/mta`;
export const CONFIRM_QUOTE_MTA_API_URL = `${API_PREFIX}lansdown/mta/confirm`;



export const CONFIRM_QUOTE_MTA_AMEND_API_URL = `${API_PREFIX}lansdown/mta/confirm/amend`;
export const CALCULATE_QUOTE_MTA_API_URL = `${API_PREFIX}lansdown/mta/calculate`;
export const CALCULATE_QUOTE_AMEND_MTA_API_URL = `${API_PREFIX}lansdown/mta/calculate/amend`;
export const AMEND_QUOTE_MTA_API_URL = `${API_PREFIX}lansdown/mta/amendQuote`;
export const CALCULATE_QUOTE_VIEW_MODE = `${API_PREFIX}lansdown/mta/view`

export const POSTCODE_LOOKUP_URL = `${API_PREFIX}postcode-lookup/`;

export const QUOTE_RENEWALS_URL = `${API_PREFIX}admin/quote-renewals`;
export const QUOTE_CLAIM_URL = `${API_PREFIX}admin/quote-claim/{quoteId}`;
export const QUOTE_CLAIMS_URL = `${API_PREFIX}admin/quote-claims`;
export const QUOTE_PATCH_URL = `${API_PREFIX}lansdown/quote/`;
export const QUOTE_RENEW_URL = `${API_PREFIX}admin/quote/{id}/renew`;
export const QUOTE_NOTES_URL = `${API_PREFIX}admin/quote/{id}/notes`;
export const QUOTE_POLICIES_URL = `${API_PREFIX}admin/quote-policies`;
export const QUOTE_QUOTES_URL = `${API_PREFIX}admin/amend-quotes`;

export const QUOTE_CALCULATE_CANCEL_URL = `${API_PREFIX}cancellation/quote/{id}/calculate-cancellation`;
export const QUOTE_CANCEL_URL = `${API_PREFIX}cancellation/quote/{id}/cancel`;

export const POST_POLICY_HOLDER_AUTH = `${API_PREFIX}policy-holder-auth`;
export const GET_POLICY_HOLDER_RENEWAL = `${API_PREFIX}policy-holder-auth/send-renewal-reminder`;
export const GET_POLICY_HOLDER_DURATION = `${API_PREFIX}policy-holder-auth/duration`;
export const SEND_PORTAL_ACCESS_LINK = `${API_PREFIX}policy-holder-auth/send-portal-access`;
export const CUSTOMER_PORTAL_QUOTES = `${API_PREFIX}portal/quotes/{email}`;
export const CUSTOMER_PORTAL_SEND_DOCUMENTS = `${API_PREFIX}portal/documents/{policyNumber}`;

export const GET_ALL_INSURERS = `${API_PREFIX}insurer`;
export const RULES_FILE_UPLOAD = `${API_PREFIX}rules-file/upload`;
export const RULES_FILE_GET_FILES_FOR_VALIDATION = `${API_PREFIX}rules-file/validate`;
export const RULES_FILE_GET_FILES_FOR_ARCHIVE = `${API_PREFIX}rules-file/`;
export const RULES_FILE_LOAD_FILE_BY_NAME = `${API_PREFIX}admin/reload-rules/{fileName}`;
export const RULES_FILE_VALIDATE_QUOTE = `${API_PREFIX}lansdown/validation/{insurerId}`;
export const RULES_FILE_VALIDATE_FILE = `${API_PREFIX}rules-file/validate/{id}`;
export const RULES_FILE_DELETE_FILE = `${API_PREFIX}rules-file/delete/{id}`;
export const RULES_FILE_DOWNLOAD_FILE = `${API_PREFIX}rules-file/{fileName}`;

export const CUSTOMER_CLAIM = `${API_PREFIX}claim-document`;
export const CUSTOMER_CLAIM_MESSAGE = `${API_PREFIX}claim-message`;
export const STRIPE_PAYMENT_REFUND = `${API_PREFIX}payment-intent/refund`;

export const CLAIM_URL = `${API_PREFIX}claim`;
export const CLAIM_READ_URL = `${API_PREFIX}claim-message/readMessages`;
export const CLAIM_MESSAGES_URL = `${API_PREFIX}claim-message/claim/{id}`;
